// Initialize emotion with CSP nonce before any component imports
import createEmotion from 'create-emotion';
createEmotion(typeof global !== 'undefined' ? global : {}, { nonce: 'Y29kaW5nYmFyMjAyNg' });

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// Ads tracking tool
import ReactGA from 'react-ga';

import i18n from './lang/i18n';
import route from './route';
import createStore from './redux/storeCreator';

import 'normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './../design/postcss/general.scss';

import moment from 'moment';
moment.locale('zh-TW');

const store = createStore({});
const routes = route();
const appRoot = document.getElementById('app');

// [GTM removed] GTM requires unsafe-eval which violates CSP policy
// window.dataLayer = window.dataLayer || [];
// (function() {
//   var s = document.createElement('script');
//   s.async = true;
//   s.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-N4BLDFV';
//   document.head.appendChild(s);
// })();

// Tracking Ads config setting
ReactGA.initialize('UA-129789023-1');


window.addEventListener("unhandledrejection", function (event) {
  console.warn("WARNINGGGGG: Unhandled promise rejection. Reason: " + event.reason, event);
  console.warn(event);
});

ReactDOM.render(

  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <span className="notranslate"> {routes} </span>
    </I18nextProvider>
  </Provider>,
  appRoot,
);
